module.exports = __webpack_public_path__ + "static/hunter-douglas-duette-f4a52167023aef2a0a1c269615668c99.png";